import React from 'react';
import { Route } from 'react-router-dom';
import InventoryIcon from "@mui/icons-material/Inventory";
import InfoIcon from "@mui/icons-material/Info";
import ProductsList from '../pages/ProductsList';
import ProductDetails from '../pages/ProductDetails';
import { RoutePathProps } from '../../../AppRoutes/types';
import AddProduct from '../pages/AddProduct';
import EditProduct from '../pages/EditProduct';
// import EditProduct from '../pages/EditProduct';

const inventory: RoutePathProps = {
  name: "inventory",
  path: "/inventory",
  label: "Inventory",
  icon: InventoryIcon,
  visibleInNav: true,
  requiredPermission: 'inventory:list',
  children: [
    {
      name: "productDetail",
      path: "/inventory/:id",
      label: "Product Details",
      icon: InfoIcon,
      requiredPermission: 'inventory:read'
    },
    {
      name: "addProduct",
      path: "/inventory/addProduct",
      label: "Add Product",
      icon: InfoIcon,
      requiredPermission: 'inventory:create'
    },
    {
      name: "editProduct",
      path: "/inventory/editProduct/:id",
      label: "Edit Product",
      icon: InfoIcon,
      requiredPermission: 'inventory:update'
    },
    // {
    //   name: "addProduct",
    //   path: "/inventory/addProduct/:itemId",
    //   label: "Add Product",
    //   icon: InfoIcon,
    // },
  ],
};

const InventoryRoutes = (
  <>
    <Route path={inventory.path} element={<ProductsList />} />
    <Route path={inventory.children?.[0].path} element={<ProductDetails />} />
    <Route path={inventory.children?.[1].path} element={<AddProduct />} />
    {/* <Route path={inventory.children?.[2].path} element={<AddProduct />} /> */}
    <Route path={inventory.children?.[2].path} element={<EditProduct />} />
    {/* <Route path={inventory.children?.[3].path} element={<AddProduct />} /> */}

  </>
);
export const inventoryPaths = [inventory];
export default InventoryRoutes;
